// extracted by mini-css-extract-plugin
export default {"container":"SK-z","topReviewHeading":"TK-z","criticalReview":"UK-z","favorableReview":"VK-z","vsSeparator":"WK-z"};